import { CSSProperties } from 'react';
import { usePlaceholderStyles } from './placeholders.styles';

export function BoxPlaceholder({
  width,
  height,
  borderColor,
  borderRadius,
  backgroundColor,
  style,
  children
}: {
  width?: string;
  height?: string;
  borderColor?: string;
  borderRadius?: string;
  backgroundColor?: string;
  style?: CSSProperties;
  children?: React.ReactNode;
}) {
  const classes = usePlaceholderStyles({
    boxWidth: width,
    boxHeight: height,
    boxBorderColor: borderColor,
    boxBorderRadius: borderRadius,
    boxBackgroundColor: backgroundColor
  });
  return (
    <div style={style} className={[classes.box, classes.pulse].join(' ')}>
      {children}
    </div>
  );
}
